// configureStore will call combineReducer with rootReducer
import resourcesAssignmentRootReducer, { resourcesAssignmentSliceId } from 'src/features/resources-assignment/slice';
import productsRootReducer, { productsSliceId } from 'src/features/products-v2/slice';
import subscriberRootReducer, { subscribersSliceId } from 'src/features/subscribers/slice';
import currentUserRootReducer, { currentUserSliceId } from 'src/features/current-user/slice';
import contentAssignmentRootReducer, { contentAssignmentSliceId } from 'src/features/content-assignment/slice';
import bulkUserImportRootReducer, { bulkImportUsersSliceId } from 'src/features/bulk-users-import/slice';
import { contentAssignmentApi } from 'src/features/content-assignment/services/contentAssignmentService';
import { appRolesApi } from 'src/features/application-roles/services/appRolesService';
import { bulkUserImportApi } from 'src/features/bulk-users-import/services/bulkUserImportService';
import { authenticationApi } from 'src/features/authentication-v2/services/authenticationService';
import { minimalResourcesAccessApi } from 'src/features/resources-assignment/services/minimalResourcesAccessService';

const rootReducer = {
    [resourcesAssignmentSliceId]: resourcesAssignmentRootReducer,
    [productsSliceId]: productsRootReducer,
    [subscribersSliceId]: subscriberRootReducer,
    [currentUserSliceId]: currentUserRootReducer,
    [contentAssignmentSliceId]: contentAssignmentRootReducer,
    [contentAssignmentApi.reducerPath]: contentAssignmentApi.reducer,
    [bulkImportUsersSliceId]: bulkUserImportRootReducer,
    [bulkUserImportApi.reducerPath]: bulkUserImportApi.reducer,
    [appRolesApi.reducerPath]: appRolesApi.reducer,
    [authenticationApi.reducerPath]: authenticationApi.reducer,
    [minimalResourcesAccessApi.reducerPath]: minimalResourcesAccessApi.reducer,
};

export default rootReducer;
